export default (function (_a) {
    var baseUnit = _a.theme.constants.SIZE_SUB_UNIT, width = _a.width;
    if (typeof width === "object") {
        var _b = width.min, min = _b === void 0 ? "" : _b, _c = width.max, max = _c === void 0 ? "" : _c;
        return "\n      ".concat(min && "min-width: ".concat(typeof min === "number" ? "".concat(baseUnit * min, "px") : min, ";"), "\n      ").concat(max && "max-width: ".concat(typeof max === "number" ? "".concat(baseUnit * max, "px") : max, ";"), "\n    ");
    }
    return width && "width: ".concat(typeof width === "number" ? "".concat(baseUnit * width, "px") : width, ";");
});
